import { invalidateCache } from 'api/urql/helpers/mutation';

export const handleFavorite = (results, args, cache, info) => {
  // handlers go here
  invalidateCache('paginatedTeams')(
    results,
    args,
    cache,
    info
  );
};
